import axios from 'axios';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useParams, useNavigate } from 'react-router-dom';

function Contact() {

    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const navigate = useNavigate();
    const [contact, setContact] = useState({
        IdContact: 0,
        IdContactOrigin: 0,
        cntName: '',
        cntEmail: '',
        cntMessage: '',
        cntCreatedIn: new Date().toISOString(),
        cntCreatedBy: '',
        cntReadIn: '',
        cntReadBy: '',
        cntCodeGUID: '',
        cntStatus: 1
    });

    function handleInputChange(event) {
        const { name, value } = event.target;
        setContact({ ...contact, [name]: value });
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        if(contact.cntName && contact.cntEmail && contact.cntMessage) {
            // code to send the contact data to the backend API
            const dataToSend = {
                IdContact: contact.IdContact,
                IdContactOrigin: contact.IdContactOrigin,
                cntName: contact.cntName,
                cntEmail: contact.cntEmail,
                cntMessage: contact.cntMessage,
                cntCreatedIn: contact.cntCreatedIn,
                cntCreatedBy: contact.cntEmail,
                cntReadIn: contact.cntReadIn,
                cntReadBy: contact.cntReadBy,
                cntCodeGUID: uuidv4(),
                cntStatus: contact.cntStatus
            };
            axios
            .post(process.env.REACT_APP_API_URL + `/routes.php?method=createContact`, 
                dataToSend,
                { headers: { 
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8' 
                } 
                })
            .then(response => {
                console.log('Form submitted:', response.data);
                alert('Thank you for contacting us! We will get back to you as soon as possible.');
                // reset the form after submission
                setContact({
                    IdContact: 0,
                    IdContactOrigin: 0,
                    cntName: '',
                    cntEmail: '',
                    cntMessage: '',
                    cntCreatedIn: new Date().toISOString(),
                    cntCreatedBy: '',
                    cntReadIn: '',
                    cntReadBy: '',
                    cntCodeGUID: '',
                    cntStatus: 1
                });
                navigate('/');
            })
            .catch(error => {
                console.error('Error submitting form:', error);
            });
        } 
    }

    // console.log(contact);
    // console.log(process.env.REACT_APP_API_URL);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div>
                        <label>Contact Us</label>
                    </div>
                </div>
                <div className="pr8 pl8 mt2 text-align-left">
                    <label className='labelTitulo' >If you have any questions or need assistance, please feel free to contact us at 
                        <a style={{textDecoration: 'none'}} href="mailto:taxlowprices@gmail.com"> taxlowprices@gmail.com</a>.
                    </label>
                </div>
                <div className="pr8 pl8 mt2 text-align-left">
                    <label className='labelTitulo'>Or you can fill out the form below and we will get back to you as soon as possible.</label>
                </div>
                {/* um formulário de contato para obter informações de contato do visitante com campos Nome, Email e Mensagem */}
                <div className='pr8 pl8 text-align-left'>
                    <div>
                        <form className='mt4' onSubmit={handleFormSubmit}>
                            <div className="w100">
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Name</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="text" name="cntName" defaultValue={contact.cntName} onChange={handleInputChange} className="p1 fs12 w100 text-align-left borderRadius"  placeholder='Your Name' required />
                                </div>
                            </div>
                            
                            <div className="w100 mt1">
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Email</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <input type="email" name="cntEmail" defaultValue={contact.cntEmail} onChange={handleInputChange} className=" p1 fs12 w100 text-align-left borderRadius"  placeholder='Your Email' required />
                                </div>
                            </div>

                            <div className="w100 mt1">
                                <div className='text-align-left divForm fs16'>
                                    <label className='labelTitulo'>Message</label>
                                </div>
                                <div className='text-align-left divForm w100 fs12'>
                                    <textarea name="cntMessage" defaultValue={contact.cntMessage} onChange={handleInputChange} className="p1 fs12 w100 text-align-left borderRadius"  placeholder='Your Message' required></textarea>
                                </div>
                            </div>
                            <div className="text-align-right">
                                <button type="submit" className=' mt2 mb4 p1 borderRadius fs12' style={{ textDecoration: 'none', cursor: 'pointer' }}>SEND MESSAGE</button>
                            </div>
                        </form>
                    </div>
                </div>

            </main>
        </div>
    );
}

export default Contact;